export const env = {
  websocketUrl: process.env.REACT_APP_WEBSOCKET_URL,
  apiURL: process.env.REACT_APP_API_URL
};

export const entries = {
  rowPerPage : process.env.REACT_APP_ROW_PER_PAGE
}